import { DictionaryFactory, DictionaryInterface } from './repository';
import React, { useContext } from 'react';

const DictionaryContext = React.createContext<Partial<DictionaryInterface>>(DictionaryFactory({ items: [] }));

interface DictionaryContextProviderProps {
	children?: React.ReactNode;
	dictionary: Dictionary.Items;
}
export const DictionaryContextProvider = ({ dictionary, children }: DictionaryContextProviderProps) => {
	const dictionaryRepository = DictionaryFactory(dictionary);
	return <DictionaryContext.Provider value={dictionaryRepository}>{children}</DictionaryContext.Provider>;
};

export function useDictionaryContext(): Partial<DictionaryInterface> {
	return useContext(DictionaryContext);
}
